import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cv-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {

    public tooltip: string = '';
    public left: number = 0;
    public top: number = 0;
    public position: 'top' | 'bottom' | 'right' | 'left' = 'bottom';

    constructor() {
        //
     }
}